module.exports = __webpack_public_path__ + "img/poster (10).db884e0d.jpg";